import React, { useState } from "react";
import CreateCircularAPI from "../api/CreateCircularAPI";
import AlertComponent from "../../../components/AlertComponent";
import TextAreaField from "../../../components/TextAreaField";
import InputField from "../../../components/InputField";
import HandlerInputChange from "../../../utils/HandleInputChange";
import ErrorAlert from "../../../components/ErrorAlert";

const CreateCircularForm = () => {
  // Variable
  const [formData, setFormData] = useState({
    title: "",
    content: "",
  });
  const [alert, setAlert] = useState("null");

  //   CreateCircular Handler (Sending Notification for all Distributors)
  const CreateCircularHandler = async (e) => {
    e.preventDefault();
    const status = await CreateCircularAPI({
      title: formData.title,
      content: formData.content,
    });
    status === 201 ? setAlert("success") : setAlert("error");

    setTimeout(() => {
      setAlert("null");
    }, 5000);
  };

  return (
    <form className="w-full border-t py-10" onSubmit={CreateCircularHandler}>
      {alert === "success" ? (
        <AlertComponent
          title="تم إرسال التعميم بنجاح"
          content={` عنوان التعميم الذي تم إرساله: ${formData.title}`}
        />
      ) : alert === "error" ? (
        <ErrorAlert title={"حدث خطا ما "} content={"حدث خطا ما في ارسال التعميم"} />
      ) : (
        ""
      )}
      <InputField
        name="title"
        label="العنوان"
        value={formData.title}
        onChange={(e) => {
          HandlerInputChange(e, setFormData);
        }}
      />
      <TextAreaField
        name="content"
        label="النص"
        value={formData.content}
        onChange={(e) => {
          HandlerInputChange(e, setFormData);
        }}
      />
      <button
        type="submit"
        className="rounded border-0 bg-indigo-500 px-6 py-2 text-lg text-white hover:bg-indigo-600 focus:outline-none"
      >
        إرسال تعميم
      </button>
    </form>
  );
};

export default CreateCircularForm;
